module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-lazyload-01.f6891e36.jpg";